import { get, size } from "lodash";

import { fetchPost } from "../api/fetch";

import { getUser } from "../utils/users";

import {
  EVENTS_REQUEST,
  RECEIVE_EVENT_GROUPS,
  RECEIVE_CHILD_EVENT_GROUPS,
  RECEIVE_EVENTS,
  EVENTS_FAILED,
} from "../constants/actionTypes";

import { eventGroupsData } from "../constants/eventGroups";

export const fetchEventGroups = (limit = 10, offset = 0, ids, parentIds) => {
  return async (dispatch, getState) => {
    const isFetching = get(getState(), ["events", "isFetching"]);
    if (!isFetching) {
      try {
        dispatch({
          type: EVENTS_REQUEST,
          child: get(parentIds, [0]) || false,
        });

        let body = {
          pagination: {
            limit,
            offset,
          },
          data: eventGroupsData,
        };

        // Filters
        if (ids || parentIds) {
          body.filter = {};
          if (ids) body.filter.ids = ids;
          if (parentIds) body.filter.parent_ids = parentIds;
        }

        let eventGroups = await fetchPost("new/event_groups", body);
        eventGroups.items = await fetchCreatedByUsers(
          get(eventGroups, ["items"])
        );

        if (!parentIds || get(parentIds, [0]) === null) {
          // Store root items
          dispatch({
            type: RECEIVE_EVENT_GROUPS,
            eventGroups: get(eventGroups, ["items"]),
            total: get(eventGroups, ["total"]),
          });
        } else {
          // Add child event groups to corresponding item
          dispatch({
            type: RECEIVE_CHILD_EVENT_GROUPS,
            parentId: get(parentIds, [0]),
            childEventGroups: get(eventGroups, ["items"]),
          });
        }
      } catch (e) {
        dispatch({ type: EVENTS_FAILED });
      }
    }
  };
};

export const fetchEvents = (limit = 10, offset = 0) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: EVENTS_REQUEST });
      let events = await fetchPost("new/events", {
        pagination: {
          limit,
          offset,
        },
        data: [
          "id",
          "parent_event_id",
          "active",
          "created_on",
          "created_by",
          "type",
          "profile",
          "zone",
          "event_count",
          "attributes",
          "notes",
          "images",
          "luke_index",
          "device",
          "group",
          "event_version",
        ],
      });
      events.items = await fetchCreatedByUsers(get(events, ["items"]));
      dispatch({
        type: RECEIVE_EVENTS,
        events: get(events, ["items"]),
        total: get(events, ["total"]),
      });
    } catch (e) {
      dispatch({ type: EVENTS_FAILED });
    }
  };
};

const fetchCreatedByUsers = async (events) => {
  for (let i = 0; i < size(events); i++) {
    let e = get(events, [i]);
    if (e.created_by && !isNaN(parseInt(e.created_by))) {
      let usr = await getUser(e.created_by);
      e.created_by = `${get(usr, ["profile", "firstname"])} ${get(usr, [
        "profile",
        "lastname",
      ])}`;
    }
    if (size(get(e, ["events"])) > 0) {
      e.events = await fetchCreatedByUsers(get(e, ["events"]));
    }
  }
  return events;
};
